import React, { useEffect } from 'react';

import { useCurrentEditor } from '@tiptap/react';

import useInterruptedAIOptimizer from '../../hooks/useInterruptedAIOptimizer';

const AiSpellCheckerSettings = () => {
    const { editor } = useCurrentEditor();

    const { initializeSpellCheckerWhenInterrupted } = useInterruptedAIOptimizer(editor);

    useEffect(() => {
        initializeSpellCheckerWhenInterrupted();
    }, [editor, initializeSpellCheckerWhenInterrupted]);

    return <></>;
};

export default AiSpellCheckerSettings;
